/* ============================================================
   Cart Drawer Vitamii — interactions v3 (UI optimiste = ultra rapide)
   - Abonnement / poids : MAJ instantanée de l'UI au clic, puis synchro des
     chiffres depuis la réponse /cart/change (SANS re-render → pas de flicker).
   - Poids : instantané + debounced (un seul appel même en cliquant vite).
   - Cross-sell add : re-render natif (le nombre d'articles change).
   ============================================================ */
(function () {
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble', 'cart-icon-bubble--mobile'];
  var addBusy = false;
  var weightTimer = null;
  var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

  /* ---------- estimation de livraison (2–3 jours ouvrés, hors WE + fériés FR) ---------- */
  function iso(d){ return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0'); }
  // Dimanche de Pâques (algorithme de Meeus/Butcher) → sert aux fériés mobiles.
  function easterSunday(Y){
    var a=Y%19, b=Math.floor(Y/100), c=Y%100, d=Math.floor(b/4), e=b%4,
        f=Math.floor((b+8)/25), g=Math.floor((b-f+1)/3),
        h=(19*a+b-d-g+15)%30, i=Math.floor(c/4), k=c%4,
        l=(32+2*e+2*i-h-k)%7, m=Math.floor((a+11*h+22*l)/451),
        mo=Math.floor((h+l-7*m+114)/31), da=((h+l-7*m+114)%31)+1;
    return new Date(Y, mo-1, da);
  }
  // Jours fériés français (métropole) calculés pour n'importe quelle année, mémoïsés.
  var feriesCache={};
  function feriesFor(year){
    if(feriesCache[year]) return feriesCache[year];
    var set={}, add=function(dt){ set[iso(dt)]=1; };
    // fixes : Jour de l'An, Fête du Travail, Victoire 1945, Fête nationale,
    //         Assomption, Toussaint, Armistice, Noël
    [[0,1],[4,1],[4,8],[6,14],[7,15],[10,1],[10,11],[11,25]].forEach(function(md){ add(new Date(year,md[0],md[1])); });
    // mobiles (Pâques) : Lundi de Pâques (+1), Ascension (+39), Lundi de Pentecôte (+50)
    var pa=easterSunday(year);
    [1,39,50].forEach(function(off){ var dt=new Date(pa); dt.setDate(dt.getDate()+off); add(dt); });
    feriesCache[year]=set; return set;
  }
  function isWorkday(d){ var w=d.getDay(); return w!==0 && w!==6 && !feriesFor(d.getFullYear())[iso(d)]; }
  function addWorkdays(s,n){ var d=new Date(s),c=0; while(c<n){ d.setDate(d.getDate()+1); if(isWorkday(d)) c++; } return d; }
  function computeEta(){
    try{
      var t=new Date(), lo=addWorkdays(t,2), hi=addWorkdays(t,3);
      var fmt=new Intl.DateTimeFormat('fr-FR',{day:'numeric',month:'long'});
      var same=lo.getMonth()===hi.getMonth()&&lo.getFullYear()===hi.getFullYear();
      var dates='entre le '+(same?lo.getDate():fmt.format(lo))+' et le '+fmt.format(hi);
      var plain='Livraison estimée '+dates;
      // dates en corail (gras) ; on compare le textContent (sans balises) pour ne pas boucler avec l'observer.
      document.querySelectorAll('.vt-eta-text').forEach(function(el){
        if(el.textContent!==plain) el.innerHTML='Livraison estimée <b class="vt-eta-d">'+dates+'</b>';
      });
    }catch(e){}
  }

  /* ---------- helpers ---------- */
  function euro(c){ return (c/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2})+' €'; }
  function postJSON(url, payload){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)}).then(function(r){return r.json();});
  }
  function getCart(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
  }
  // Applique un changement puis synchronise depuis /cart.js.
  // IMPORTANT : la réponse de /cart/change.js a un total_price parfois gonflé
  // par une app tierce (ex. Point Relais/Colissimo = +2,90 €). On ne se fie
  // JAMAIS à son total ; on relit /cart.js (propre) avant d'afficher.
  function changeThenSync(body){
    return postJSON(changeUrl, body).then(getCart).then(syncFromCart);
  }

  /* ---------- récap sous-total : MAJ des lignes depuis l'objet cart ---------- */
  function setMoney(sel, c, neg){ var el=document.querySelector(sel); if(el) el.textContent=(neg?'−':'')+euro(c); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  // regroupe les remises (line-level + cart-level) par titre+type, libellées code vs auto
  function renderDiscountLines(cart){
    var cont=document.querySelector('.vt-recap__discounts'); if(!cont) return;
    var map={}, order=[];
    function add(title,type,amt){ var k=(title||'')+'\u0000'+(type||''); if(map[k]==null){map[k]=0;order.push(k);} map[k]+=amt; }
    (cart.items||[]).forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(a){ var da=a.discount_application||{}; add(da.title,da.type,a.amount); }); });
    (cart.cart_level_discount_applications||[]).forEach(function(d){ add(d.title,d.type,d.total_allocated_amount); });
    var html='';
    order.forEach(function(k){ var amt=map[k]; if(amt<=0) return; var p=k.split('\u0000');
      var label = p[1]==='discount_code' ? ('Code promo · '+esc(p[0])) : (esc(p[0])||'Réduction');
      html+='<div class="vt-recap__row vt-recap__row--disc"><span>'+label+'</span><span>−'+euro(amt)+'</span></div>'; });
    cont.innerHTML=html;
  }
  function updateRecap(cart){
    var recap=document.querySelector('.vt-recap'); if(!recap) return;
    var sav=0;
    (cart.items||[]).forEach(function(it){ var a=it.selling_plan_allocation; if(a && a.compare_at_price){ sav += (a.compare_at_price - a.price)*it.quantity; } });
    var disc=cart.total_discount||0;
    recap.classList.toggle('vt-recap--flat', !(sav>0 || disc>0)); // aucune remise → seule la ligne Total
    setMoney('.vt-recap__val--subtotal', cart.total_price + sav + disc); // prix plein
    var aboRow=recap.querySelector('.vt-recap__row--abo');
    if(aboRow){ aboRow.style.display = sav>0?'':'none'; setMoney('.vt-recap__val--abo', sav, true); }
    renderDiscountLines(cart);
    setMoney('.vt-recap__val--total', cart.total_price);
  }

  /* ---------- code promo vs abonnement (non cumulable) ----------
     Détecte si un code promo a sauté suite à un abonnement. Comme Shopify retire le code
     ET peut réordonner les lignes, on fait un RE-RENDER complet pour tout resynchroniser
     (prix des lignes, badges remise natifs, récap, bloc promo), puis on affiche le message. */
  function cartHasCode(cart){
    var found=false;
    (cart.items||[]).forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(a){ if((a.discount_application||{}).type==='discount_code') found=true; }); });
    (cart.cart_level_discount_applications||[]).forEach(function(d){ if(d.type==='discount_code') found=true; });
    return found;
  }
  function syncPromo(cart){
    var promo=document.querySelector('.vt-promo'); if(!promo) return false;
    var hasCode=cartHasCode(cart);
    var chip=promo.querySelector('.vt-promo__chip');
    if(!hasCode && chip){
      // code retiré (non cumulable avec l'abonnement) → re-render complet + message
      reloadDrawer().then(function(){
        var err=document.querySelector('.vt-promo [data-promo-err]');
        if(err){ err.textContent='Code non cumulable avec l\'abonnement, il a été retiré.'; err.hidden=false; }
      }).catch(function(){});
      return true;
    }
    if(hasCode && !chip){ reloadDrawer().catch(function(){}); return true; }
    return false;
  }

  /* ---------- synchro des chiffres depuis l'objet cart (PAS de re-render) ---------- */
  function syncFromCart(cart){
    if(!cart || cart.total_price==null) return;
    if(syncPromo(cart)) return; // re-render complet en cours → inutile de patcher l'ancien DOM
    // Dès qu'une remise est en jeu (Pack auto, code…), la structure prix (barré empilé) + badge
    // est trop complexe pour un patch optimiste → on laisse le SERVEUR tout recalculer/réafficher.
    if((cart.total_discount||0) > 0 || document.querySelector('.drawer__cart-item .discounts__discount')){ reloadDrawer().catch(function(){}); return; }
    updateRecap(cart);
    updateProgress(cart.total_price);
    (cart.items||[]).forEach(function(it,i){
      var line=document.getElementById('CartDrawer-Item-'+(i+1)); if(!line) return;
      var p=line.querySelector('.drawer__cart-item__totals .price, .drawer__cart-item__totals .price__sale');
      if(p){ p.innerHTML = (it.original_line_price!==it.final_line_price)
        ? '<s class="vt-strike">'+euro(it.original_line_price)+'</s> '+euro(it.final_line_price)
        : euro(it.final_line_price); }
    });
  }
  function updateProgress(total){
    var pg=document.querySelector('.vt-progress'); if(!pg) return;
    var th=+pg.dataset.threshold||6000, rem=th-total, pct=Math.min(100,total*100/th);
    var f=pg.querySelector('.vt-progress__fill'); if(f) f.style.width=pct+'%';
    var ic=pg.querySelector('.vt-progress__ic'); if(ic) ic.classList.toggle('is-reached', rem<=0);
    var tx=pg.querySelector('.vt-progress__text');
    if(tx) tx.innerHTML = rem<=0 ? '<strong>Livraison offerte débloquée</strong>'
      : 'Plus que <strong>'+euro(rem)+'</strong> pour la livraison offerte';
  }
  function updateSavings(sav){
    var el=document.querySelector('.vt-foot-save');
    if(sav>0){
      if(!el){ var eta=document.querySelector('.vt-eta'); el=document.createElement('p'); el.className='vt-foot-save';
        if(eta&&eta.parentNode) eta.parentNode.insertBefore(el,eta); }
      el.textContent='Vous économisez '+euro(sav)+' grâce à votre abonnement'; el.style.display='';
    } else if(el){ el.style.display='none'; }
  }

  /* ---------- UI optimiste de la ligne (instantané) ---------- */
  function freqFromText(t){ return t ? t.replace('Livré ','').split(' · ')[0] : 'au bon rythme'; }
  function setLineSubUI(line, on, freqLabel){
    var w=line.querySelector('.vt-weights'); if(w) w.classList.toggle('mm-none', !on);
    var sub=line.querySelector('.vt-sub__sub');
    if(sub) sub.textContent = on ? (freqLabel ? ('Livré '+freqLabel+' · sans engagement') : 'Livré au rythme de votre chien · sans engagement')
                                  : 'Livré au rythme de votre chien · sans engagement';
  }

  /* ---------- ABONNEMENT : case (capture + stopPropagation) ---------- */
  document.addEventListener('change', function(e){
    var cb=e.target.closest && e.target.closest('.vt-sub__check'); if(!cb) return;
    e.stopPropagation();
    var on=cb.checked, line=cb.closest('.drawer__cart-item');
    // 1) instantané
    setLineSubUI(line, on, null);
    if(on) line.querySelectorAll('.vt-weights__pills button').forEach(function(b){ b.classList.remove('active'); });
    else clearWeightFlag(line);
    // 2) mutation + synchro chiffres (sans re-render).
    //    On cible la ligne par son INDEX (stable) : la clé change quand le plan change.
    changeThenSync({line:parseInt(cb.dataset.line,10)||1, quantity:parseInt(cb.dataset.qty,10)||1, selling_plan: on?cb.dataset.plan:null})
      .catch(function(){});
  }, true);

  /* ---------- ABONNEMENT : poids (instantané + debounced) ---------- */
  document.addEventListener('click', function(e){
    var pill=e.target.closest && e.target.closest('.vt-weights__pills button'); if(!pill) return;
    var wrap=pill.closest('.vt-weights'); if(!wrap || !pill.dataset.plan) return;
    var line=wrap.closest('.drawer__cart-item'), freq=pill.dataset.freq;
    // instantané
    wrap.querySelectorAll('button').forEach(function(b){ b.classList.remove('active'); });
    pill.classList.add('active');
    clearWeightFlag(line);
    var sub=line.querySelector('.vt-sub__sub'); if(sub) sub.textContent='Livré '+freq+' · sans engagement';
    // mutation debounced (prix inchangé → pas de synchro nécessaire)
    clearTimeout(weightTimer);
    var line=parseInt(wrap.dataset.line,10)||1, qty=parseInt(wrap.dataset.qty,10)||1, plan=pill.dataset.plan;
    weightTimer=setTimeout(function(){ changeThenSync({line:line, quantity:qty, selling_plan:plan}).catch(function(){}); }, 250);
  });

  /* ---------- VALIDATION : abonné SANS poids choisi → bloque le checkout ---------- */
  function subItemsMissingWeight(){
    var out=[];
    document.querySelectorAll('.drawer__cart-item').forEach(function(item){
      var cb=item.querySelector('.vt-sub__check');
      if(cb && cb.checked){
        var w=item.querySelector('.vt-weights');
        if(w && !w.classList.contains('mm-none') && !w.querySelector('.vt-weights__pills button.active')){ out.push(item); }
      }
    });
    return out;
  }
  function flagWeight(item){
    var w=item.querySelector('.vt-weights'); if(!w) return;
    var msg=w.querySelector('.vt-weights__need');
    if(!msg){
      msg=document.createElement('div'); msg.className='vt-weights__need'; msg.setAttribute('role','alert');
      msg.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h16.9a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>Choisissez le poids de votre chien';
      w.appendChild(msg);
    }
    w.classList.add('vt-weights--need');
    w.classList.remove('vt-weights--shake'); void w.offsetWidth; w.classList.add('vt-weights--shake');
  }
  function clearWeightFlag(item){
    if(!item) return; var w=item.querySelector('.vt-weights'); if(!w) return;
    w.classList.remove('vt-weights--need','vt-weights--shake');
  }
  function blockIfMissingWeight(e){
    var bad=subItemsMissingWeight();
    if(!bad.length) return true;
    if(e){ e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    bad.forEach(flagWeight);
    var w=bad[0].querySelector('.vt-weights'); if(w) w.scrollIntoView({behavior:'smooth', block:'center'});
    return false;
  }
  document.addEventListener('submit', function(e){ var f=e.target; if(f && f.id==='CartDrawer-Form') blockIfMissingWeight(e); }, true);
  document.addEventListener('click', function(e){ var b=e.target.closest && e.target.closest('#CartDrawer-Checkout'); if(b) blockIfMissingWeight(e); }, true);

  /* ---------- CROSS-SELL : ajout (re-render natif, le nb d'articles change) ---------- */
  function innerFromSection(html, sel){ try{ var d=new DOMParser().parseFromString(html,'text/html'); var el=d.querySelector(sel); return el?el.innerHTML:null; }catch(e){ return null; } }
  function renderDrawer(state){
    if(!state || !state.sections) return;
    var inner=innerFromSection(state.sections['cart-drawer'], '.drawer__inner');
    var dest=document.querySelector('cart-drawer .drawer__inner');
    if(inner!=null && dest) dest.innerHTML=inner;
    ['cart-icon-bubble','cart-icon-bubble--mobile'].forEach(function(id){
      if(!state.sections[id]) return;
      var node=document.getElementById(id), html=innerFromSection(state.sections[id], '.shopify-section');
      if(node && html!=null) node.innerHTML=html;
    });
    if(window.Loox && window.Loox.refresh){ try{ window.Loox.refresh(); }catch(e){} }
    computeEta();
  }
  document.addEventListener('click', function(e){
    var btn=e.target.closest && e.target.closest('.vt-xadd'); if(!btn) return;
    e.preventDefault(); if(addBusy) return; addBusy=true; btn.classList.add('is-loading');
    postJSON(addUrl,{items:[{id:btn.dataset.variant, quantity:1}], sections:SECTIONS, sections_url:window.location.pathname})
      .then(renderDrawer).catch(function(){})
      .then(function(){ addBusy=false; btn.classList.remove('is-loading'); });
  });

  /* ---------- CROSS-SELL : flèches ---------- */
  document.addEventListener('click', function(e){
    var arr=e.target.closest && e.target.closest('.vt-xsell__arrow'); if(!arr) return;
    var track=arr.closest('.vt-xsell').querySelector('.vt-xsell__track'); if(!track) return;
    var card=track.firstElementChild, step=(card?card.getBoundingClientRect().width:200)+10;
    track.scrollBy({left: parseInt(arr.dataset.dir,10)*step, behavior:'smooth'});
  });

  /* ---------- CROSS-SELL : compteur "i/N" + points suivent le scroll (délégué en capture, survit aux re-renders) ---------- */
  document.addEventListener('scroll', function(e){
    var tr=e.target && e.target.closest && e.target.closest('.vt-xsell__track'); if(!tr) return;
    var cards=tr.children; if(!cards.length) return;
    var step=cards[0].getBoundingClientRect().width+10;
    var i=Math.round(tr.scrollLeft/step); if(i<0)i=0; if(i>cards.length-1)i=cards.length-1;
    var xs=tr.closest('.vt-xsell'); if(!xs) return;
    xs.querySelectorAll('.vt-xsell__dots i').forEach(function(d,k){ d.classList.toggle('on', k===i); });
    var c=xs.querySelector('.vt-xsell__count'); if(c) c.textContent=(i+1)+' / '+cards.length;
    var pa=xs.querySelector('.vt-bom__nav .vt-xsell__arrow[data-dir="-1"]');
    var na=xs.querySelector('.vt-bom__nav .vt-xsell__arrow[data-dir="1"]');
    if(pa||na){ var maxSL=tr.scrollWidth-tr.clientWidth; if(pa) pa.classList.toggle('is-off', tr.scrollLeft<=2); if(na) na.classList.toggle('is-off', tr.scrollLeft>=maxSL-2); }
  }, true);

  /* ---------- CODE PROMO : application / retrait (via /discount/ + re-render) ----------
     Shopify n'applique pas les codes via l'AJAX cart ; on passe par le permalien
     /discount/CODE (pose le cookie de remise), puis on recharge la section du tiroir. */
  function reloadDrawer(){
    return fetch('/?sections='+SECTIONS.join(','), {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); }).then(function(secs){ renderDrawer({sections:secs}); });
  }
  // titres des remises de TYPE code présentes dans le panier (line + cart level)
  function codeDiscTitles(cart){
    var t=[];
    (cart.items||[]).forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(a){ var da=a.discount_application||{}; if(da.type==='discount_code'&&da.title) t.push(da.title); }); });
    (cart.cart_level_discount_applications||[]).forEach(function(d){ if(d.type==='discount_code'&&d.title) t.push(d.title); });
    return t;
  }
  document.addEventListener('click', function(e){
    var btn=e.target.closest && e.target.closest('[data-promo-apply]'); if(!btn) return;
    var wrap=btn.closest('.vt-promo'), input=wrap && wrap.querySelector('[data-promo-input]');
    var code=input ? input.value.trim() : ''; if(!code) return;
    var err=wrap.querySelector('[data-promo-err]'); if(err) err.hidden=true;
    if(!btn.dataset.lbl) btn.dataset.lbl=btn.textContent;
    btn.disabled=true; btn.textContent='…';
    // Stratégie « cumul d'abord » : l'offre baume (BAUMECART50) est combinable, donc on
    // tente le code client PAR-DESSUS sans rien retirer → un code combinable (ex. GESTE)
    // s'ajoute et l'offre baume RESTE. Seulement s'il est refusé (code NON cumulable bloqué
    // par le slot baume) on libère le baume et on réessaie → le code client gagne alors.
    var before={disc:0, titles:[]};
    function succeeded(cart){
      // robuste aux codes dont le titre Shopify ≠ le code tapé (SMS/Loox/affiliés) :
      // succès = une remise-code absente avant est apparue, OU la remise totale a augmenté.
      var t=codeDiscTitles(cart);
      var newCode=t.some(function(x){ return before.titles.indexOf(x)<0; });
      return newCode || (cart.total_discount||0) > before.disc;
    }
    getCart().then(function(c0){ before.disc=c0.total_discount||0; before.titles=codeDiscTitles(c0); })
      // 1) tentative SANS retirer le baume : un code combinable se cumule avec l'offre baume
      .then(function(){ return fetch('/discount/'+encodeURIComponent(code), {headers:{'Accept':'text/html'}}); })
      .then(getCart)
      .then(function(cart){
        if(succeeded(cart)) return reloadDrawer();                         // cumulé avec le baume ✔
        // 2) refusé → on libère le slot (retire le baume) et on réessaie le code client
        return postJSON('/cart/update.js',{discount:''})
          .then(function(){ return fetch('/discount/'+encodeURIComponent(code), {headers:{'Accept':'text/html'}}); })
          .then(getCart)
          .then(function(cart2){
            if(succeeded(cart2)) return reloadDrawer();                     // code non cumulable : il gagne, l'offre baume cède
            // 3) vraiment invalide → message contextualisé + on restaure l'offre baume
            var hasSub=(cart2.items||[]).some(function(it){ return it.selling_plan_allocation; });
            var hasAuto=false;
            (cart2.items||[]).forEach(function(it){ (it.line_level_discount_allocations||[]).forEach(function(a){ var da=a.discount_application||{}; if(da.title && da.type!=='discount_code') hasAuto=true; }); });
            (cart2.cart_level_discount_applications||[]).forEach(function(d){ if(d.title && d.type!=='discount_code') hasAuto=true; });
            var msg = hasSub
              ? "Code non cumulable avec un abonnement, décochez « S'abonner » pour l'utiliser."
              : hasAuto
                ? "Une remise est déjà appliquée à votre panier ; ce code ne s'ajoute pas par-dessus."
                : "Code invalide ou expiré, ou conditions non remplies (montant minimum, produits éligibles).";
            return fetch('/discount/'+BAUME_CODE,{headers:{'Accept':'text/html'}}).then(function(){
              if(err){ err.textContent=msg; err.hidden=false; }
              btn.disabled=false; btn.textContent=btn.dataset.lbl;
            });
          });
      })
      .catch(function(){ if(err){ err.textContent='Une erreur est survenue, réessayez.'; err.hidden=false; } btn.disabled=false; btn.textContent=btn.dataset.lbl; });
  });
  document.addEventListener('click', function(e){
    var x=e.target.closest && e.target.closest('[data-promo-remove]'); if(!x) return;
    x.disabled=true;
    // retire le code promo (les remises automatiques restent) puis recharge le tiroir
    postJSON('/cart/update.js', {discount:''}).catch(function(){})
      .then(function(){ return reloadDrawer(); }).catch(function(){ x.disabled=false; });
  });
  document.addEventListener('click', function(e){
    var t=e.target.closest && e.target.closest('[data-promo-toggle]'); if(!t) return;
    var wrap=t.closest('.vt-promo'), rev=wrap && wrap.querySelector('[data-promo-reveal]');
    if(rev) rev.hidden=false;
    t.hidden=true;
    var input=wrap && wrap.querySelector('[data-promo-input]'); if(input) input.focus();
  });
  document.addEventListener('keydown', function(e){
    if(e.key!=='Enter') return;
    var input=e.target.closest && e.target.closest('[data-promo-input]'); if(!input) return;
    e.preventDefault();
    var btn=input.closest('.vt-promo').querySelector('[data-promo-apply]'); if(btn) btn.click();
  });

  /* ---------- recalcul de l'ETA après le re-render natif du drawer ----------
     Le thème remplace tout `.drawer__inner` à chaque MAJ qté / suppression →
     `.vt-eta-text` repasse au placeholder « Livraison estimée… ». On observe le
     host `cart-drawer` (persistant) et on relance computeEta après chaque rerender. */
  /* ---------- OFFRE BAUME : code interne -50% auto-injecte (cumulable avec les remises auto, contrairement a une 2e remise auto) ----------
     IMPORTANT : Shopify garde dans cart.discount_codes les codes NON applicables
     (ex. un code resté en cookie mais inapplicable au panier courant, type GESTE).
     On raisonne donc sur le flag `applicable`, jamais sur la simple présence :
       - on (ré)applique BAUMECART50 dès que le baume est au panier sans sa remise active ;
       - un code inapplicable resté en mémoire ne doit JAMAIS bloquer l'offre baume ;
       - on respecte en revanche un code CLIENT réellement actif (applicable). */
  var BAUME_CODE='BAUMECART50', BAUME_HANDLE='baume-protecteur-et-reparateur-pour-coussinets', baumeBusy=false;
  function autoBaume(){
    if(baumeBusy) return;
    getCart().then(function(c){
      var codes=c.discount_codes||[];
      var baumeOk     = codes.some(function(d){ return d.code===BAUME_CODE && d.applicable; }); // remise baume déjà active
      var baumeThere  = codes.some(function(d){ return d.code===BAUME_CODE; });                  // code baume présent (même inapplicable)
      var otherActive = codes.some(function(d){ return d.code!==BAUME_CODE && d.applicable; });  // un code CLIENT réellement actif
      var inC=(c.items||[]).some(function(it){ return it.handle===BAUME_HANDLE; });
      // On (ré)applique tant que le baume n'a pas sa remise — MÊME si un code client est actif :
      // s'il est cumulable (ex. GESTE) l'offre baume s'ajoute, s'il ne l'est pas Shopify la
      // refuse (elle reste listée inapplicable). Anti-boucle : on ne retente PAS quand le code
      // baume est déjà présent-mais-inapplicable À CAUSE d'un code client actif (slot pris).
      if(inC && !baumeOk && !(baumeThere && otherActive)){
        baumeBusy=true;
        fetch('/discount/'+BAUME_CODE,{headers:{'Accept':'text/html'}}).then(function(){ baumeBusy=false; return reloadDrawer(); }).catch(function(){ baumeBusy=false; });
      } else if(!inC && baumeThere && !otherActive){
        // baume retiré et aucun code client actif → on nettoie le code interne
        baumeBusy=true;
        postJSON('/cart/update.js',{discount:''}).then(function(){ baumeBusy=false; return reloadDrawer(); }).catch(function(){ baumeBusy=false; });
      }
    }).catch(function(){});
  }

  function observeDrawer(){
    var host=document.querySelector('cart-drawer')||document.getElementById('CartDrawer');
    if(!host||!window.MutationObserver) return;
    var pending=false;
    new MutationObserver(function(){
      if(pending) return; pending=true;
      setTimeout(function(){ pending=false; computeEta(); autoBaume(); }, 0); // debounce le burst de mutations
    }).observe(host, {childList:true, subtree:true});
  }

  function initEta(){ computeEta(); autoBaume(); observeDrawer(); }
  if(document.readyState!=='loading') initEta();
  else document.addEventListener('DOMContentLoaded', initEta);
})();
